import { MINUTE } from 'shared/time';

const getRemainTime = (preparingTime?: number, approvedDate?: Date) => {
	if (!preparingTime || !approvedDate) return;

	const finishedDate = new Date(approvedDate.getTime() + preparingTime * MINUTE);

	return Math.max(Math.ceil((finishedDate.getTime() - Date.now()) / MINUTE), 0);
};

export default getRemainTime;
